module.exports = __webpack_public_path__ + "static/media/services.e9561f85.jpg";